import { orm } from 'synergy/models';
// import Restaurant from './Restaurant';
import SalesChannel from './SalesChannel';

// orm.register(Restaurant);
orm.register(SalesChannel);

// export { Restaurant };
export { orm, SalesChannel };
